import { Box, type SxProps, type Theme } from "@mui/material";

import { FERNIE_TILE_PATH } from "~/components/fernie/fernieArt";
import { clampMarkSize, type FernieMicroVariant, resolveMicroVariant } from "~/components/fernie/fernieMarkRules";
import { fernieColors } from "~/themes/fernieBrand";

interface FernieMicroProps {
	size?: number;
	variant?: FernieMicroVariant;
	decorative?: boolean;
	title?: string;
	sx?: SxProps<Theme>;
}

const FernieMicro = ({ size = 24, variant, decorative = false, title = "fernie", sx }: FernieMicroProps) => {
	const resolved = variant ?? resolveMicroVariant(size);
	const width = clampMarkSize(resolved === "eyes" ? "eyes" : "micro", size);

	return (
		<Box
			component="svg"
			role="img"
			aria-hidden={decorative || undefined}
			aria-label={decorative ? undefined : title}
			viewBox="0 0 48 48"
			sx={{ display: "block", height: width, width, ...sx }}
			xmlns="http://www.w3.org/2000/svg"
		>
			<path d={FERNIE_TILE_PATH} fill={fernieColors.tile} />
			{resolved === "eyes" ? (
				<>
					<rect x="12.2" y="17.5" width="6.6" height="10" rx="3.3" fill={fernieColors.led} />
					<rect x="29.2" y="17.5" width="6.6" height="10" rx="3.3" fill={fernieColors.led} />
				</>
			) : (
				<>
					<rect x="12.8" y="15" width="6.2" height="9" rx="3.1" fill={fernieColors.led} />
					<rect x="29" y="15" width="6.2" height="9" rx="3.1" fill={fernieColors.led} />
					<path
						d="M17.5 32 Q24 37 30.5 32"
						stroke={fernieColors.led}
						strokeWidth="3"
						strokeLinecap="round"
						fill="none"
					/>
				</>
			)}
		</Box>
	);
};

export default FernieMicro;
